import featureVideoConfig from './feature/video'

const translateVideoConfig = featureVideoConfig.translate

const SUPPRESSED_PLAYER_ERRORS = featureVideoConfig.suppressedPlayerErrors

export { translateVideoConfig, SUPPRESSED_PLAYER_ERRORS }
